export default __webpack_public_path__ + "static/media/About_BG-Shapes-01.60865e97.png";